// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1Qh-7","additionalInfo":"AgreementModal_additionalInfo__3QtIZ"};